import {BaseService} from "./base.service";

class RelServicesSupplierService extends BaseService {

    constructor() {
        super('api/rel-services-supplier')
    }

}

export const relservicessupplierService = new RelServicesSupplierService();
